export default __webpack_public_path__ + "static/media/customizations.afc854cf.png";